import { useRemoteAudio } from 'features/streaming/useRemoteAudio';

interface RemoteAudioProps {
  mid: string;
}

export const RemoteAudio = ({ mid }: RemoteAudioProps) => {
  useRemoteAudio(mid);

  return null;
};
